import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#1c2b39',
                secondary: '#1c2b39',
                accent: '#1c2b39',
                error: '#b71c1c',
            },
        },
    },
});
